<!-- ═══ PAGE HEADER ═══ -->
<div class="page-header">
  <div class="page-header-inner">
    <div class="page-header-breadcrumb">
      <a routerLink="/">Início</a>
      <i class="fas fa-chevron-right"></i>
      <span>Explorar Campanhas</span>
    </div>

    <div class="page-header-row">
      <div>
        <h1>Explorar Campanhas</h1>
        <div class="page-header-meta">
          Mostrando <strong>{{ pagination.totalRecords || campanhas.length }}</strong> campanhas activas em Angola
        </div>
      </div>
      <a routerLink="/criar-campanha" class="btn btn-primary btn-rounded">
        <i class="fas fa-plus"></i> Criar Campanha
      </a>
    </div>

    <!-- STATS ROW -->
    <div class="explore-stats">
      <div class="explore-stat">
        <div class="explore-stat-dot"></div>
        <div>
          <div class="explore-stat-val">{{ (stats.totalArrecadado || 0) | number:'1.0-0' }}</div>
          <div class="explore-stat-label">Pagamentos confirmados</div>
        </div>
      </div>
      <div class="explore-stat">
        <div class="explore-stat-dot amber"></div>
        <div>
          <div class="explore-stat-val">{{ stats.taxaSucesso ?? 0 }}%</div>
          <div class="explore-stat-label">Taxa de sucesso</div>
        </div>
      </div>
      <div class="explore-stat">
        <div class="explore-stat-dot blue"></div>
        <div>
          <div class="explore-stat-val">{{ (stats.apoiadoresActivos || 0) | number }}</div>
          <div class="explore-stat-label">Apoiadores activos</div>
        </div>
      </div>
      <div class="explore-stat">
        <div class="explore-stat-dot"></div>
        <div>
          <div class="explore-stat-val">{{ stats.provinciasCount || 18 }} Províncias</div>
          <div class="explore-stat-label">Cobertura nacional</div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ═══ CATEGORY CHIPS STRIP ═══ -->
<div class="category-chips-strip">
  <div class="category-chips">
    <button type="button" class="chip" [class.active]="selectedCategory === null" (click)="filterCat(null)">
      <span class="chip-icon"><i class="fas fa-th-large"></i></span> Todas
      <span class="chip-count" *ngIf="pagination.totalRecords">({{ pagination.totalRecords }})</span>
    </button>

    <button type="button" class="chip" *ngFor="let cat of categoriaList" [class.active]="selectedCategory === cat.id"
      (click)="filterCat(cat.id)">
      <span class="chip-icon"><i [class]="getCategoryIcon(cat.descricao)"></i></span>
      <span>{{ cat.descricao }}</span>
      <span class="chip-count" *ngIf="cat.totalCampanhas">({{ cat.totalCampanhas }})</span>
    </button>
  </div>
</div>

<!-- ═══ MAIN LAYOUT ═══ -->
<div class="explore-layout">

  <!-- LEFT COLUMN -->
  <main>
    <!-- FILTERS BAR CARD -->
    <div class="filters-bar-card">
      <!-- Linha 1: Pesquisa por Nome e Dropdowns -->
      <div class="fbc-main-row">
        <!-- Campo de Pesquisa por Nome / Título -->
        <div class="fbc-search-wrap">
          <i class="fas fa-search fbc-search-icon"></i>
          <input
            type="text"
            class="fbc-search-input"
            placeholder="Pesquisar por título ou nome da campanha..."
            [(ngModel)]="searchQuery"
            (input)="onSearchInput()"
            (keydown.enter)="onSearch()"
          />
          <button
            *ngIf="searchQuery"
            type="button"
            class="fbc-clear-btn"
            (click)="searchQuery = ''; onSearch()"
            title="Limpar pesquisa"
          >
            <i class="fas fa-times"></i>
          </button>
          <button
            type="button"
            class="fbc-search-btn"
            (click)="onSearch()"
            title="Buscar campanhas"
          >
            <i class="fas fa-search"></i>
            <span>Buscar</span>
          </button>
        </div>

        <!-- Dropdowns de Financiamento e Ordenação -->
        <div class="fbc-dropdowns-group">
          <!-- Tipo de Financiamento -->
          <div class="fbc-filter-item">
            <span class="fbc-filter-label">
              <i class="fas fa-hand-holding-dollar"></i> Financiamento:
            </span>
            <p-select
              [options]="tipoFinanciamentoList"
              [(ngModel)]="selectedTipoFinanciamento"
              (onChange)="onTipoFinanciamentoChange($event.value)"
              placeholder="Todos os tipos"
              class="fbc-p-select"
              optionLabel="label"
              optionValue="id"
              [showClear]="true"
            />
          </div>

          <!-- Ordenar -->
          <div class="fbc-filter-item">
            <span class="fbc-filter-label">
              <i class="fas fa-sort-amount-down"></i> Ordenar:
            </span>
            <p-select
              [options]="sortOptions"
              [(ngModel)]="selectedSort"
              (onChange)="onSortChange($event.value)"
              placeholder="Mais Recentes"
              class="fbc-p-select"
              optionLabel="label"
              optionValue="value"
              [showClear]="true"
            />
          </div>
        </div>
      </div>

      <!-- Linha 2: Checkbox Encerradas, Total Encontradas e Alternador Grid/Lista -->
      <div class="fbc-sub-row">
        <div class="fbc-meta-left">
          <!-- Checkbox Encerradas -->
          <label class="fbc-checkbox-label">
            <input
              type="checkbox"
              [checked]="mostrarEncerradas"
              (change)="toggleEncerradas()"
            />
            <span>Mostrar encerradas</span>
          </label>

          <span class="fbc-meta-divider">•</span>

          <!-- Contador de Resultados -->
          <div class="fbc-results-badge">
            <strong>{{ pagination.totalRecords || campanhas.length }}</strong>
            <span>campanhas encontradas</span>
          </div>
        </div>

        <!-- Alternador Grid / Lista -->
        <div class="view-toggle">
          <button
            type="button"
            class="view-btn"
            [class.active]="viewMode === 'grid'"
            (click)="setView('grid')"
            title="Vista em grelha"
          >
            <i class="fas fa-th"></i>
          </button>
          <button
            type="button"
            class="view-btn"
            [class.active]="viewMode === 'list'"
            (click)="setView('list')"
            title="Vista em lista"
          >
            <i class="fas fa-list"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- LOADING SKELETON -->
    <div *ngIf="loading" class="grid-view loading-grid">
      <div class="skeleton-card" *ngFor="let s of [1,2,3,4]">
        <div class="sk-img shimmer"></div>
        <div class="sk-body">
          <div class="sk-line title shimmer"></div>
          <div class="sk-line org shimmer"></div>
          <div class="sk-line text shimmer"></div>
          <div class="sk-bar shimmer"></div>
        </div>
      </div>
    </div>

    <!-- CAMPAIGNS CONTAINER -->
    <div *ngIf="!loading && campanhas.length > 0" [ngClass]="viewMode === 'grid' ? 'grid-view' : 'list-view'"
      id="campaignsContainer">
      <!-- ═══ GRID VIEW ═══ -->
      <ng-container *ngIf="viewMode === 'grid'">
        <article class="campaign-card" *ngFor="let camp of campanhas">
          <div class="campaign-card-img">
            <img *ngIf="camp.fotoUrl" [src]="camp.fotoUrl" [alt]="camp.titulo" class="campaign-card-img-real" />
            <div *ngIf="!camp.fotoUrl" class="campaign-card-img-placeholder"
              [style.background]="getPlaceholderGradient(camp.categoria?.descricao)">
              <i [class]="getCategoryIcon(camp.categoria?.descricao)" class="placeholder-icon"></i>
            </div>

            <div class="campaign-card-badges">
              <div class="cc-badges-left">
                <span class="cc-badge-cat">
                  <i [class]="getCategoryIcon(camp.categoria?.descricao)"></i>
                  {{ camp.categoria?.descricao || 'Geral' }}
                </span>
                <span class="cc-badge-type" *ngIf="camp.tipoFinanciamento || camp.tipoFinanciamentoENUM">
                  <i [class]="getTipoFinanciamentoIcon(camp.tipoFinanciamentoENUM || camp.tipoFinanciamento)"></i>
                  {{ camp.tipoFinanciamento || getTipoFinanciamentoLabel(camp.tipoFinanciamentoENUM) }}
                </span>
              </div>
              <span class="cc-badge-days" [class.urgent]="isUrgent(camp.dataTermino)"
                [class.warning]="isWarning(camp.dataTermino)"
                [class.normal]="!isUrgent(camp.dataTermino) && !isWarning(camp.dataTermino)">
                <i class="fas fa-clock"></i> {{ getDiasRestantes(camp.dataTermino) }}
              </span>
            </div>
            <span class="cc-badge-featured" *ngIf="camp.destaque || camp.emDestaque">
              <i class="fas fa-fire"></i> Em Destaque
            </span>
          </div>

          <div class="campaign-card-body">
            <h3 class="campaign-card-title">{{ camp.titulo }}</h3>
            <div class="campaign-card-org">
              <i class="fas fa-circle-check"></i>
              {{ camp.utilizador?.nomeCompleto || camp.utilizador?.userName || 'FundCube Criador' }} · {{
              camp.provincia?.descricao || 'Angola' }}
            </div>
            <p class="campaign-card-desc line-clamp-2">
              {{ cleanDescription(camp.descricaoBreve || camp.descricao, 140) }}
            </p>

            <div class="campaign-card-progress">
              <div class="cc-progress-top">
                <span class="cc-amount">{{ (camp.valorArrecado || 0) | money }} Kz</span>
                <span class="cc-pct-badge" [class.high]="getPercent(camp) >= 70"
                  [class.mid]="getPercent(camp) >= 30 && getPercent(camp) < 70" [class.low]="getPercent(camp) < 30">
                  {{ getPercent(camp) }}%
                </span>
              </div>

              <div class="cc-progress-bar">
                <div class="cc-progress-fill" [class.mid]="getPercent(camp) >= 30 && getPercent(camp) < 70"
                  [class.low]="getPercent(camp) < 30" [style.width.%]="getPercent(camp) > 100 ? 100 : getPercent(camp)">
                </div>
              </div>

              <div class="cc-meta">
                <div class="cc-meta-item">
                  <i class="fas fa-users"></i> {{ camp.totalDoadores || 0 }} apoiadores
                </div>
                <div class="cc-meta-item" [class.urgent]="isUrgent(camp.dataTermino)">
                  <i class="fas fa-clock"></i> {{ getDiasRestantes(camp.dataTermino) }}
                </div>
              </div>
            </div>

            <a [routerLink]="['/detalhe-campanha', camp.id]" class="btn btn-primary btn-full btn-rounded btn-sm"
              style="margin-top:auto;">
              <i class="fas fa-heart"></i> Financiar
            </a>
          </div>

          <div class="campaign-card-footer">
            <div class="cc-social">
              <button type="button" class="cc-social-btn" [class.liked]="likedSet.has(camp.id)"
                (click)="toggleLike(camp)">
                <i [class]="likedSet.has(camp.id) ? 'fas fa-heart' : 'far fa-heart'"></i>
                <span>{{ camp.totalCurtidas || 0 }}</span>
              </button>
              <button type="button" class="cc-social-btn"
                [class.active]="showCommentModal && activeCommentCamp?.id === camp.id"
                (click)="openCommentModal(camp, $event)" title="Comentar campanha">
                <i class="far fa-comment"></i>
                <span>{{ camp.totalComentarios || 0 }}</span>
              </button>
              <button type="button" class="cc-social-btn" (click)="shareCard(camp)" title="Partilhar">
                <i class="fas fa-share-nodes"></i>
              </button>
            </div>
          </div>
        </article>
      </ng-container>

      <!-- ═══ LIST VIEW ═══ -->
      <ng-container *ngIf="viewMode === 'list'">
        <article class="campaign-card-list" *ngFor="let camp of campanhas">
          <div class="ccl-img">
            <img *ngIf="camp.fotoUrl" [src]="camp.fotoUrl" [alt]="camp.titulo" class="ccl-img-real" />
            <div *ngIf="!camp.fotoUrl" class="ccl-img-inner"
              [style.background]="getPlaceholderGradient(camp.categoria?.descricao)">
              <i [class]="getCategoryIcon(camp.categoria?.descricao)" class="placeholder-icon"></i>
            </div>
            <div class="ccl-badges">
              <span class="cc-badge-cat">
                <i [class]="getCategoryIcon(camp.categoria?.descricao)"></i>
                {{ camp.categoria?.descricao || 'Geral' }}
              </span>
              <span class="cc-badge-type" *ngIf="camp.tipoFinanciamento || camp.tipoFinanciamentoENUM">
                <i [class]="getTipoFinanciamentoIcon(camp.tipoFinanciamentoENUM || camp.tipoFinanciamento)"></i>
                {{ camp.tipoFinanciamento || getTipoFinanciamentoLabel(camp.tipoFinanciamentoENUM) }}
              </span>
            </div>
          </div>

          <div class="ccl-body">
            <div class="ccl-header">
              <div>
                <h3 class="ccl-title">{{ camp.titulo }}</h3>
                <div class="ccl-org">
                  <i class="fas fa-circle-check"></i>
                  {{ camp.utilizador?.nomeCompleto || camp.utilizador?.userName || 'FundCube Criador' }} · {{
                  camp.provincia?.descricao || 'Angola' }}
                </div>
              </div>
              <span class="cc-pct-badge" [class.high]="getPercent(camp) >= 70"
                [class.mid]="getPercent(camp) >= 30 && getPercent(camp) < 70" [class.low]="getPercent(camp) < 30">
                {{ getPercent(camp) }}%
              </span>
            </div>

            <p class="ccl-desc line-clamp-2">
              {{ cleanDescription(camp.descricaoBreve || camp.descricao, 220) }}
            </p>

            <div class="ccl-progress">
              <div class="ccl-progress-top">
                <span class="ccl-amount">{{ (camp.valorArrecado || 0) | money }} Kz</span>
                <span class="text-xs text-muted">Meta: {{ (camp.metaArrecadar || 0) | money }} Kz</span>
              </div>
              <div class="cc-progress-bar">
                <div class="cc-progress-fill" [style.width.%]="getPercent(camp) > 100 ? 100 : getPercent(camp)"></div>
              </div>
              <div class="ccl-meta-row">
                <div class="ccl-meta-item">
                  <i class="fas fa-users"></i> {{ camp.totalDoadores || 0 }} apoiadores
                </div>
                <div class="ccl-meta-item" [class.urgent]="isUrgent(camp.dataTermino)">
                  <i class="fas fa-clock"></i> {{ getDiasRestantes(camp.dataTermino) }}
                </div>
                <div class="ccl-meta-item" *ngIf="camp.dataTermino">
                  <i class="fas fa-calendar"></i> Até {{ camp.dataTermino | dateMonth }}
                </div>
              </div>
            </div>

            <div class="ccl-actions">
              <div class="ccl-social">
                <button type="button" class="ccl-social-btn" [class.liked]="likedSet.has(camp.id)"
                  (click)="toggleLike(camp)">
                  <i [class]="likedSet.has(camp.id) ? 'fas fa-heart' : 'far fa-heart'"></i>
                  <span>{{ camp.totalCurtidas || 0 }}</span>
                </button>
                <button type="button" class="ccl-social-btn"
                  [class.active]="showCommentModal && activeCommentCamp?.id === camp.id"
                  (click)="openCommentModal(camp, $event)" title="Comentar campanha">
                  <i class="far fa-comment"></i>
                  <span>{{ camp.totalComentarios || 0 }}</span>
                </button>
                <button type="button" class="ccl-social-btn" (click)="shareCard(camp)">
                  <i class="fas fa-share-nodes"></i>
                </button>
              </div>

              <a [routerLink]="['/detalhe-campanha', camp.id]" class="btn btn-primary btn-rounded btn-sm ml-auto">
                <i class="fas fa-heart"></i> Financiar
              </a>
            </div>
          </div>
        </article>
      </ng-container>
    </div>

    <!-- EMPTY STATE -->
    <div class="empty-state" *ngIf="!loading && campanhas.length === 0">
      <div class="empty-state-icon"><i class="fas fa-search"></i></div>
      <h3>Nenhuma campanha encontrada</h3>
      <p>Tente ajustar os termos da pesquisa, seleccionar outra categoria, tipo de financiamento ou limpar os filtros.
      </p>
      <button class="btn btn-outline btn-rounded" (click)="clearAllFilters()">
        Limpar Filtros
      </button>
    </div>

    <!-- PAGINATION -->
    <div class="pagination" *ngIf="!loading && (pagination.totalPages || 1) > 1">
      <button type="button" class="page-btn" [class.disabled]="(pagination.pageNumber || 1) <= 1"
        (click)="onPageChange((pagination.pageNumber || 1) - 1)">
        <i class="fas fa-chevron-left"></i>
      </button>

      <ng-container *ngFor="let p of getPageNumbers()">
        <button *ngIf="p !== '...'" type="button" class="page-btn" [class.active]="p === (pagination.pageNumber || 1)"
          (click)="onPageChange(+p)">
          {{ p }}
        </button>
        <div *ngIf="p === '...'" class="page-ellipsis">…</div>
      </ng-container>

      <button type="button" class="page-btn"
        [class.disabled]="(pagination.pageNumber || 1) >= (pagination.totalPages || 1)"
        (click)="onPageChange((pagination.pageNumber || 1) + 1)">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </main>

  <!-- RIGHT SIDEBAR (EXATAMENTE COMO NO PROTÓTIPO) -->
  <aside>
    <div class="sidebar-sticky">

      <!-- TOP CAMPANHAS DE SUCESSO (TRANSFERIDAS DA HOME) -->
      <div class="sidebar-card">
        <div class="sidebar-card-header">
          <div class="sidebar-card-title">
            <i class="fas fa-trophy" style="color:var(--amber-500);margin-right:6px;"></i>
            Top Campanhas de Sucesso
          </div>
          <span class="sidebar-card-action" (click)="toggleEncerradas()">
            {{ mostrarEncerradas ? 'Activas' : 'Ver todas' }}
          </span>
        </div>

        <div class="success-list" *ngIf="campanhasSucesso.length > 0; else noSuccess">
          <div class="success-item" *ngFor="let item of campanhasSucesso" [routerLink]="['/detalhe-campanha', item.id]">
            <div class="success-item-title">{{ item.titulo }}</div>
            <div class="success-item-meta">
              <div class="success-meta-row">
                <div class="success-meta-item">
                  <i class="fas fa-calendar"></i> {{ item.dataTermino | dateMonth }}
                </div>
                <div class="success-meta-item">
                  <i class="fas fa-map-marker-alt"></i> {{ item.provincia?.descricao || 'Angola' }}
                </div>
              </div>
              <div class="success-meta-row">
                <div class="success-meta-item">
                  <i class="fas fa-users"></i> {{ item.totalDoadores || 0 }} Doadores
                </div>
              </div>
            </div>

            <div class="success-amounts">
              <span class="success-meta-val">Meta: {{ (item.metaArrecadar || 0) | money }} Kz</span>
              <span class="success-received">{{ (item.valorArrecado || 0) | money }} Kz</span>
            </div>

            <div class="success-progress">
              <div class="success-progress-fill"
                [style.width.%]="getPercent(item) > 100 ? 100 : (getPercent(item) || 100)"></div>
            </div>

            <span class="badge badge-green" style="display:block;text-align:center;margin:8px 0 4px;"
              *ngIf="getPercent(item) >= 100">
              <i class="fas fa-circle-check mr-1"></i> Meta 100% Atingida!
            </span>

            <a class="success-detail-link" [routerLink]="['/detalhe-campanha', item.id]">
              <i class="fas fa-arrow-right"></i> Ver detalhes
            </a>
          </div>
        </div>

        <ng-template #noSuccess>
          <div style="padding:var(--sp-6);text-align:center;color:var(--text-muted);font-size:var(--text-xs);">
            <i class="fas fa-award text-2xl mb-2 text-amber-500" style="display:block;"></i>
            A carregar campanhas de sucesso em destaque...
          </div>
        </ng-template>
      </div>

      <!-- CATEGORY QUICK FILTER -->
      <div class="sidebar-card">
        <div class="sidebar-card-header">
          <div class="sidebar-card-title">
            <i class="fas fa-filter" style="color:var(--primary);margin-right:6px;"></i>
            Filtrar por Categoria
          </div>
        </div>
        <div class="quick-filters">
          <div class="qf-item" [class.active]="selectedCategory === null" (click)="filterCat(null)">
            <div class="qf-label">
              <div class="qf-icon"><i class="fas fa-th-large"></i></div> Todas as Categorias
            </div>
            <span class="qf-count">{{ pagination.totalRecords || 0 }}</span>
          </div>

          <div class="qf-item" *ngFor="let cat of categoriaList" [class.active]="selectedCategory === cat.id"
            (click)="filterCat(cat.id)">
            <div class="qf-label">
              <div class="qf-icon"><i [class]="getCategoryIcon(cat.descricao)"></i></div> {{ cat.descricao }}
            </div>
            <span class="qf-count" *ngIf="cat.totalCampanhas">{{ cat.totalCampanhas }}</span>
          </div>
        </div>
      </div>

      <!-- PROVINCE FILTER -->
      <div class="sidebar-card">
        <div class="sidebar-card-header">
          <div class="sidebar-card-title">
            <i class="fas fa-map-marker-alt" style="color:var(--primary);margin-right:6px;"></i>
            Filtrar por Província
          </div>
          <span class="sidebar-card-action" (click)="clearProvinces()">Limpar</span>
        </div>
        <div class="province-list">
          <div class="province-item" *ngFor="let prov of provinciaList" (click)="filterProvincia(prov.id)">
            <input type="checkbox" [id]="'p_' + prov.id" [checked]="selectedProvincia === prov.id"
              (click)="$event.stopPropagation(); filterProvincia(prov.id)" />
            <label [for]="'p_' + prov.id">{{ prov.descricao }}</label>
          </div>
        </div>
      </div>

      <!-- NEWSLETTER -->
      <div class="sidebar-card">
        <div class="newsletter-widget">
          <h4><i class="fas fa-envelope-open-text mr-2" style="color:var(--primary);"></i> Receba as Melhores Campanhas
          </h4>
          <p>Subscreva e receba semanalmente os projectos angolanos com mais impacto directamente no seu email.</p>
          <div class="newsletter-form">
            <input class="newsletter-input" type="email" placeholder="o.email@exemplo.ao" [(ngModel)]="newsletterEmail"
              (keydown.enter)="subscribeNewsletter()" />
            <button type="button" class="btn btn-primary btn-full btn-rounded btn-sm" (click)="subscribeNewsletter()">
              <i class="fas fa-paper-plane"></i> Subscrever
            </button>
          </div>
        </div>
      </div>

    </div>
  </aside>

</div>

<!-- ═══ MODAL ESCREVER COMENTÁRIO ═══ -->
<div class="comment-modal-backdrop" *ngIf="showCommentModal" (click)="closeCommentModal()">
  <div class="comment-modal-dialog" (click)="$event.stopPropagation()">
    <div class="comment-modal-header">
      <div class="header-info">
        <i class="fas fa-comment"></i>
        <div class="header-titles">
          <h3>Escrever Comentário</h3>
          <span class="campaign-title-hint" *ngIf="activeCommentCamp">{{ activeCommentCamp.titulo }}</span>
        </div>
      </div>
      <button type="button" class="btn-close" (click)="closeCommentModal()" title="Fechar"
        aria-label="Fechar comentário">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <form (ngSubmit)="submitComment()">
      <div class="comment-modal-body">
        <div class="avatar-col">
          <div class="comment-user-avatar">{{ userInitials || 'U' }}</div>
        </div>
        <div class="input-col">
          <textarea class="comment-textarea" placeholder="Escreva sua mensagem ou apoio..." rows="3"
            [(ngModel)]="commentContent" name="commentContent" (keydown)="onCommentKeyDown($event)" #commentInput
            maxlength="500"></textarea>
          <div class="char-count">{{ commentContent.length }}/500</div>
        </div>
      </div>

      <div class="comment-modal-footer">
        <span class="key-hint">Pressione <kbd>Enter</kbd> para enviar</span>
        <div class="footer-actions">
          <button type="button" class="btn-cancel" (click)="closeCommentModal()">
            Cancelar
          </button>
          <button type="submit" class="btn-submit" [disabled]="isSubmittingComment || !commentContent.trim()">
            <i class="fas fa-paper-plane" *ngIf="!isSubmittingComment"></i>
            <i class="fas fa-spinner fa-spin" *ngIf="isSubmittingComment"></i>
            <span>Comentar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- TOAST NOTIFICATION -->
<div class="toast-box" [class.show]="toastVisible">
  {{ toastMessage }}
</div>